export default __webpack_public_path__ + "static/media/enghien18.7744306d.jpg";